import moment from "moment";
import { useState } from "react";



const ListDateFilters = ({fromDate,toDate,updateFromDate,updateToDate,resetClick,lebel1,lebel2}) => {



    return (
        <>
            <div className="card p-3">
            <h6>Filters</h6>
            <div class="row mt-1">
              <div class="col-12 col-md-3 ">
                <label>{lebel1}</label>
                <input
                  type="date"
                  name="start_date"
                  className="form-control form-control-lg"
                  value={fromDate}
                  onChange={(event) =>{
                    // Call the updateFromDate function with the new value
                    updateFromDate(event.target.value);
                  }}
                />
              </div>
              <div class="col-12 col-md-3 ">
                <label>{lebel2}</label>
                <input
                  type="date"
                  name="end_date"
                  className="form-control form-control-lg"
                  value={toDate}
                  onChange={(event) => {
                    // Call the updateFromDate function with the new value
                    updateToDate(event.target.value);
                  }}
                />
              </div>
              <div class="col-12 col-md-2 ">
                <button
                  type="submit"
                  className="btn btn-secondary w-80 mt-4"
                  onClick={resetClick}>
                    Reset
                </button>
              </div>
            </div>
          </div>
        </>
    )
}

export default ListDateFilters;